import teamData from "../data/team.json";
import Male from "../static/img/img/male.png";
import Female from "../static/img/img/female.png";

const TeamData = teamData.members
  .filter((m) => m.active !== false)
  .sort((a, b) => (a.order || 999) - (b.order || 999))
  .map((member) => {
    const fallback = member.gender === "male" ? Male : Female;

    return {
      id: member.id,
      name: member.name,
      designation: member.designation,
      image: member.image || fallback, // 🔥 Direct path
      fallback: fallback,
      linkedin: member.linkedin || "",
      konnectorx: member.konnectorx || "",
    };
  });

export default TeamData;
